/**
 * English copy. Ported verbatim from wechat/src/i18n/en.js.
 *
 * Shared so a wording change lands in both apps at once. If a key exists
 * here it must exist in the other language file too — see i18n/index.ts,
 * which fails loudly on a missing key rather than rendering the key name.
 */
export const en = {
  'ev.pullToRefresh': 'Pull to refresh',
  'ev.releaseToRefresh': 'Release to refresh',
  'ev.linkCopied': 'Link copied',
  'ev.shareHint': 'Tap ··· to share this table',
  'ev.notFound': 'This table is no longer available.',
  'sms.kicker': 'Join free',
  'sms.title': 'Your phone number',
  'sms.sub': 'We text you a 6-digit code. No password to remember.',
  'sms.phonePlaceholder': 'Mobile number',
  'sms.codePlaceholder': 'Code',
  'sms.sendCode': 'Send code',
  'sms.verify': 'Continue',
  'sms.codeSent': 'Code sent',
  'sms.sendFailed': "We couldn't send the code. Try again.",
  'sms.wrongCode': 'That code is not right.',
  'sms.invalidPhone': 'Enter a valid mobile number',
  'sms.enterCode': 'Enter the code we texted you',
  'sms.legal': 'By continuing you agree to our terms and privacy policy.',

  'brand.suffix': 'Social Dining',

  'nav.apply': 'Apply',
  'nav.dining': 'Social Dining',
  'nav.six': 'The Six',
  'nav.profile': 'Profile',

  'common.loading': 'Loading…',
  'common.optional': 'optional',
  'common.back': 'Back',
  'common.empty': 'Nothing here yet.',
  'common.continue': 'Continue',
  'common.retry': 'Try again',
  'common.yes': 'Yes',
  'common.no': 'No',

  'choose.kicker': 'Before we seat you',
  'choose.title': 'What brings you to the table?',
  'choose.sub': 'Pick the one that fits you best today. It shapes the few questions we ask — and who we sit you next to.',
  'choose.foot': 'You can change this later — some people come for one thing and stay for another.',

  'apply.reviewed': 'Reviewed personally · most hear back within 48h',
  'apply.submit': 'Submit application',
  'apply.save': 'Save changes',
  'apply.back': '← Pick a different reason',
  'apply.editnote': "You've already applied — update any answer below and save. Your place in the queue stays.",
  'apply.progress': '{n}% complete',
  'apply.fillRequired': 'Please fill the required questions first.',
  'apply.saved': 'Saved',
  'apply.submitted': 'Application submitted',
  'apply.completeFirst': 'Submit an application first to unlock this.',
  'apply.reserveNotice': 'Please register yourself first before reserving a seat at the table.',

  'onboarding.stageCore': 'Your profile',
  'onboarding.stageMatching': 'Better matches',
  'onboarding.progressStart': 'Choose to begin',
  'onboarding.progressComplete': 'Core complete',
  'onboarding.progressOne': '1 panel left',
  'onboarding.progressMany': '{n} panels left',
  'onboarding.motivationTitle': 'What brings you to the table?',
  'onboarding.motivationSub': 'Choose the one that fits you best today. It shapes the questions we ask and who we seat you with.',
  'onboarding.coreDone': 'Your profile is ready',
  'onboarding.matchTitle': 'Help us match you better?',
  'onboarding.matchSub': 'A few more answers help us find the people and tables that feel right for you.',
  'onboarding.matchNow': 'Yes, improve my matches',
  'onboarding.matchLater': "I'll finish this later",
  'onboarding.finish': 'Finish my profile',
  'onboarding.skipHint': 'You can leave this blank and continue.',
  'onboarding.answerRequired': 'Choose or enter an answer to continue.',
  'onboarding.saveFailed': "We couldn't save that. Please try again.",
  'onboarding.loadFailed': "We couldn't load your profile panels.",
  'onboarding.loadFailedSub': 'Check your connection and try again.',
  'onboarding.done': 'Profile ready',

  'restaurantFinder.pickFromList': 'Pick one from the list below.',
  'restaurantFinder.searchPlaceholder': 'Search restaurant, area, address, flavour...',
  'restaurantFinder.loading': 'Loading restaurants...',
  'restaurantFinder.defaultResults': 'Showing 20 restaurants to start',
  'restaurantFinder.results': 'Closest matches',
  'restaurantFinder.empty': 'No restaurants found.',
  'restaurantFinder.error': "Couldn't load restaurants. Please try again.",
  'restaurantFinder.rating': 'Rating',

  'gate.kicker': 'One step to begin',
  'gate.title': 'Link your WeChat',
  'gate.sub': 'Top Chopsticks seats you at tables with real people, so we link your WeChat account before you come in.',
  'gate.contract': 'Read the privacy guideline',
  'gate.agree': 'Agree and continue',
  'gate.decline': 'Not now',
  'gate.declined': 'You need to link WeChat to use the app.',
  'gate.step2': 'Almost there',
  'gate.authFailed': 'WeChat login failed',
  'gate.authFailedSub': 'You need to be signed in to use Top Chopsticks. Shared event links remain public.',

  'wxp.title': 'Use your WeChat profile?',
  'wxp.sub': 'Tap the avatar to use your WeChat picture, and the name field to fill in your WeChat name. Entirely optional — the app works the same either way.',
  'wxp.titleReq': 'Your picture and name',
  'wxp.subReq': 'Tap the field and pick your WeChat name. Adding your WeChat picture is optional — we will give you one if you skip it.',
  'wxp.continue': 'Continue',
  'wxp.needName': 'Please add your name',
  'wxp.needBoth': 'Please add both your picture and your name.',
  'wxp.avatarFailed': "Name saved — the picture couldn't be uploaded.",
  'wxp.avatarFailedTitle': "Picture couldn't be uploaded",
  'wxp.avatarFailedDetail': "Your name was saved, but your picture was not. Please try again from your profile.",
  'wxp.avatarHint': 'Tap to choose your picture',
  'wxp.namePlaceholder': 'Your name',
  'wxp.save': 'Use this',
  'wxp.skip': 'Not now',
  'wxp.saved': 'Thanks — profile updated',
  'wxp.failed': "Couldn't save that. You can try again from your profile.",
  'wxp.failedTitle': "Couldn't update your profile",
  'wxp.failedDetail': "We couldn't save your profile right now. Please try again.",

  'ev.curated': 'Curated by us',
  'ev.community': 'Community',
  'ev.info': "Everyone can see every event for now. Once the community grows, you'll filter these by what brings you here.",
  'ev.commInfo': "Community tables are hosted by members, not us. We show all of them while we're small — later you'll filter them by motivation, neighborhood and more.",
  'ev.invited': "You're invited",
  'ev.more': 'More curated tables',
  'ev.details': 'See details',
  'ev.aboutTitle': 'About this table',
  'ev.seatConfirmed': 'Your seat is confirmed.',
  'ev.hide': 'Hide details',
  'ev.reserve': 'Reserve my seat',
  'ev.join': 'Join',
  'ev.address': 'Address',
  'ev.addressCopied': 'Address copied',
  'ev.copyFailed': 'Could not copy',
  'ev.languages': 'Spoken at the table',
  'ev.qrTitle': 'Join the group chat',
  'ev.qrHint': 'Scan to join the WeChat group for this table.',
  'ev.reserveNoPay': 'Reserve my seat',
  'ev.payLaterNote': 'No payment now — settle with us at the table.',
  'ev.reserved': "You're in — we'll see you there",
  'ev.bookedLabel': "You're in ✓",
  'ev.cancelReservation': 'Cancel my reservation',
  'ev.cancelConfirmTitle': 'Cancel your seat?',
  'ev.cancelConfirm': 'Your seat goes back to the table and someone else can take it. You can book again if it is still open.',
  'ev.cancelConfirmYes': 'Yes',
  'ev.cancelConfirmNo': 'Keep',
  'ev.cancelled': 'Reservation cancelled',
  'ev.cancelFailed': 'Could not cancel — please try again.',
  'ev.share': 'Share',
  'ev.joined': "You're in — seat booked",
  'ev.joinFailed': "Couldn't book your seat. Please try again.",
  'ev.free': 'free',
  'ev.seat': 'Seat, all-in',
  'ev.seatsRemaining': 'seats remaining',
  'ev.people': 'People',
  'ev.curatedBy': 'Curated by',
  'ev.format': 'Format',
  'ev.menuPreview': 'Menu preview',
  'ev.spark': "Tonight's spark",
  'ev.fullMenu': 'Full menu — translated and filtered to your diet — revealed 24h before.',
  'ev.swipePhotos': 'Swipe for photos ›',
  'ev.vipNote': "🔒 The Six — our hand-matched VIP tables — are never listed here. They appear under The Six once you've dined with us.",
  'ev.finishedLabel': 'This event has ended',
  'ev.attendedLabel': 'You attended',
  'guest.incompleteTitle': 'Almost there',
  'guest.incompleteSub': 'You are signed in with WeChat. Finish a few questions and you can book and be matched.',
  'guest.ctaFinish': 'Finish setup',
  'guest.cta': 'Join free',
  'guest.eventsTitle': 'Join free to book a seat',
  'guest.eventsSub': 'Tell us a little about you and we will match you with the table that fits.',
  'guest.sixTitle': 'Your table, chosen for you',
  'guest.sixSub': 'Answer a few questions and our matching puts you with people you will actually want to eat with.',
  'guest.profileTitle': 'Nothing here yet',
  'guest.profileSub': 'Join free to save your profile, book seats and get matched to the right table.',
  'guest.reserveLocked': 'Join free to book a seat',
  'ev.seePast': 'See past events',
  'ev.hidePast': 'Hide past events',
  'ev.hostCta': 'Want to host your own? Tap “Organize your table”.',
  'ev.curatedHeading': 'Curated By Us',
  'ev.communityHeading': 'Community',
  'ev.emptyCurated': 'No curated tables for now — check back soon.',
  'ev.emptyCommunity': 'No community tables for now.',
  'ev.empty': 'No events yet — check back soon.',

  'fab.label': 'Organize your table',
  'org.kicker': 'Host with us',
  'org.title': 'Organize your table',
  'org.sub': "Got an idea for a dinner, a tasting, a themed night? We'll help you fill the seats. For now, just say hi on WeChat — we'll take it from there.",
  'org.can': 'What you can host',
  'org.1t': 'A curated table with us',
  'org.1d': 'We co-design it, vet the guests and handle the seating — you bring the concept.',
  'org.2t': 'A self-service community event',
  'org.2d': 'Your dinner, your rules. Post it, we help it find the right people.',
  'org.3t': 'A virtual night',
  'org.3d': 'Recipe swaps, cook-alongs, tastings over video. (coming later)',
  'org.scan': 'Scan to reach us on WeChat',
  'org.got': 'Got it',
  'orgFlow.title': 'Organize your table',
  'orgFlow.requiredPrefix': 'Required: ',
  'orgFlow.priceRequired': 'Add a price per guest for pay later.',
  'orgFlow.typeCommunity': 'Community event',
  'orgFlow.type1to1': '1 to 1',
  'orgFlow.typeKicker': 'First',
  'orgFlow.typeTitle': 'What do you want to organize?',
  'orgFlow.typeSub': 'Choose the format. We will ask a few details next.',
  'orgFlow.stageType': 'Event type',
  'orgFlow.panelPrompt': 'Tell us the useful details. You can keep it rough.',
  'orgFlow.step': 'Step {n}/{total}',
  'orgFlow.panelsLeft': '{n} left',
  'orgFlow.save': 'Save',
  'orgFlow.saved': 'Draft saved',
  'orgFlow.cancel': 'Cancel',
  'orgFlow.discardTitle': 'Discard this draft?',
  'orgFlow.discardBody': 'Unsaved changes will be lost. Save first if you want to continue later.',
  'orgFlow.keepEditing': 'Keep editing',
  'orgFlow.discard': 'Discard',
  'orgFlow.pickType': 'Choose an event type first.',
  'orgFlow.submit': 'Submit',
  'orgFlow.submitCommunity': 'Submit event',
  'orgFlow.submitOneToOne': 'Submit 1-to-1 table',
  'orgFlow.updateCommunity': 'Update event',
  'orgFlow.updateOneToOne': 'Update 1-to-1 table',
  'orgFlow.slotDuplicate': 'That time is already in your list.',
  'orgFlow.draftKept': 'Draft saved.',
  'orgFlow.pendingTag': 'Awaiting approval',
  'orgFlow.slotsHint': 'Add at least one time option.',
  'orgFlow.photoAdd': 'Choose a photo',
  'orgFlow.photoReplace': 'Replace photo',
  'orgFlow.photoHint': 'Optional · JPG or PNG · up to 5 MB',
  'orgFlow.photoTooBig': 'That image is over 5 MB.',
  'orgFlow.photoFailed': 'Upload failed. Please try again.',
  'orgFlow.pendingHint': 'Our team reviews within 24-48h.',
  'orgFlow.submitFailed': "We couldn't submit that. Please try again.",
  'orgFlow.loadFailed': "We couldn't load the organizer panels.",
  'orgFlow.loadFailedSub': 'Check your connection and try again.',
  'orgFlow.doneTitle': 'Sent for approval',
  'orgFlow.doneSub': 'Our team reviews new tables within 24-48 hours. We will get back to you here.',
  'orgFlow.updatedTitle': 'Your event idea was updated',
  'orgFlow.updatedSub': 'Our team reviews changes within 24-48 hours.',
  'orgFlow.backToEvents': 'Back to events',
  'orgFlow.myRequests': 'Your organizer requests',
  'orgFlow.waitingApproval': 'Waiting for approval',
  'orgFlow.editRequest': 'Edit',
  'orgFlow.untitledRequest': 'Untitled table idea',
  'orgFlow.people': '{n} people',

  'six.badge': 'Invitation only',
  'six.exTitle': 'The Six — a table chosen for you',
  'six.exSub': "Our VIP tables seat exactly six people we match by hand. They're never listed publicly and never appear in Social Dining.",
  'six.exHow': 'How we match you',
  'six.s1t': 'Join our events',
  'six.s1p': 'Come to a couple of curated dinners so we can see how you connect with a table.',
  'six.s2t': 'We review, personally',
  'six.s2p': "Our team looks at your profile, your dietary and interest fit, and who you've dined well with. No algorithm decides your seat.",
  'six.s3t': 'You get invited',
  'six.s3p': "When we're confident the six of you will click, we send a private invite. The only thing you'll know in advance is the date.",
  'six.exFoot': 'Access opens after your first dinner with us. Start with Social Dining.',
  'six.exCta': 'See Social Dining',
  'six.inTitle': 'A table chosen for you',
  'six.inSub': "Based on your dinners with us, we've hand-matched you with five people we believe you'll like. These tables are never listed publicly. Trust us once more.",
  'six.inWhereImg': 'Where you might be dining',
  'six.inWhen': 'When',
  'six.inWhere': 'Where',
  'six.inWho': 'Who',
  'six.inMenu': 'Menu',
  'six.inAccept': 'Accept my seat',
  'six.inSeats': 'of 6 seats remaining',
  'six.inLater': 'Maybe next time',
  'six.inExpires': 'Invite expires in',

  'pay.kicker': 'Confirm your seat',
  'pay.date': 'Date',
  'pay.seat': 'Seat',
  'pay.includes': 'Includes',
  'pay.includesv': 'Full menu · service',
  'pay.cancel': 'Cancellation',
  'pay.cancelv': 'Free >72h · 50% >24h',
  'pay.warn': 'Seats are matched to you personally — an empty chair breaks the table. No-shows forfeit the full amount.',
  'pay.pay': 'Pay with WeChat Pay',
  'pay.paid': 'Payment received',
  'pay.back': 'Back',

  'profile.member': 'Member',
  'profile.myApplication': 'My application',
  'profile.title': 'My profile',
  'profile.app': 'My application',
  'profile.herefor': 'Here for',
  'profile.status': 'Status',
  'profile.submitted': 'Submitted',
  'profile.completion': 'Profile completion',
  'profile.update': 'Update my application',
  'profile.membership': 'Membership',
  'profile.invited': 'Invited by',
  'profile.attended': 'Dinners attended',
  'profile.meetAgain': 'Meet-again received',
  'profile.referrals': 'Referrals',
  'profile.gift': '1 seat to gift',
  'profile.high': 'High',
  'profile.lang': 'Language',
  'profile.session': 'Account',
  'profile.refreshWechatLogin': 'Refresh WeChat login',
  'profile.wechatLoginRefreshed': 'WeChat login refreshed',
  'profile.wechatLoginRefreshFailedTitle': "Couldn't refresh WeChat login",
  'profile.wechatLoginRefreshFailedDetail': 'Please try again in a moment.',
  'profile.logout': 'Log out',
  'profile.login': 'Log in with WeChat',
  'profile.loginHint': "You're signed out. Log in to sync your profile and matches.",
  'profile.loggedOut': 'Signed out',
  'profile.devMode': 'DEV',
  'profile.buildVersion': 'Mini program build',
  'profile.forceSignOut': 'Force sign out (clear session)',
  'profile.sessionCleared': 'Session cleared',
  'profile.seeEventsAsPublic': 'See events as public',
  'profile.seeEventsAsSelf': 'See events as myself',
  'profile.viewPublic': 'public',
  'profile.viewSelf': 'me',
  'profile.seeProfilePanel': 'See profile panel',

  'intent.gastronomy': 'Food',
  'intent.professional_networking': 'Networking',
  'intent.local_friendships': 'Local friends',

  'tone.food': 'For the food',
  'tone.network': 'Worth knowing',
  'tone.local': 'Local friends'
} as const
